import { searchImpressions } from "./utils";
import getDatesArray from "../get-dates-array";

export default (id, start, end) => state => {
  const dates = getDatesArray(start, end);
  return searchImpressions(id)(state) ? searchImpressions(id)(state)
    .filter(e => dates.includes(e.day))
    .reverse() : [];
};
